export { default as ImageLoader } from './ImageLoader'
export { default as MiniLoader } from './MiniLoader'
export { default as PostLoader } from './PostLoader'
export { default as TextLoader } from './TextLoader'
export { default as VideoLoader } from './Video'


// WEBPACK FOOTER //
// ./src/js/components/Loaders/index.js